import { render, staticRenderFns } from "./DataTableDaily.vue?vue&type=template&id=926bbf30&"
import script from "./DataTableDaily.vue?vue&type=script&lang=js&"
export * from "./DataTableDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports